import { Layout } from '@common/layouts';
import { Box, ScrollArea } from '@radix-ui/themes';

export const OperationPage = () => {
    return (
        <Layout.Content p={'2'} overflow={'hidden'}>
            <ScrollArea type={'scroll'}>
                <Box>Operation page: work in progress...</Box>
            </ScrollArea>
        </Layout.Content>
    );
};
